import {IDataFilter} from "../../services/DataTable";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {ListResponseModel, ResponseModel} from "../response/response.model";
import {Observable} from "rxjs/Observable";
import {Injectable} from "@angular/core";
import {AreaCodesModel} from "./area-codes.model";

@Injectable()
export class AreaCodesService{

    private API_ROOT:string = '/area-codes';
    constructor(private http: Http) {}

    public static getListSubject =  null;

    getList(filter?: IDataFilter): Observable<ListResponseModel<AreaCodesModel>> {
        let params: URLSearchParams = new URLSearchParams();
        if (filter) {
            for(let key in filter) {
                params.set(key, filter[key]);
            }
        }

        AreaCodesService.getListSubject = AreaCodesService.getListSubject || this.http
                .get(this.API_ROOT, new RequestOptions({
                    search: params
                }))
                .map((res) => {
                    let response: ListResponseModel<AreaCodesModel> = res.json();

                    return response;
                });


        return AreaCodesService.getListSubject;

    }
}




// WEBPACK FOOTER //
// ./src/app/models/area-codes/area-codes.service.ts